/**
 * @license
 * Copyright UX Stack. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at LICENSE.md
 */

import { Logger } from '../../logger';
import { UXStackInterface, UXStackOptions } from '../../sdk';
import { Module } from '../module';
import { TrackingInterface } from '../tracking/tracking';

export class AutoCollectModule implements Module {
  public name: string;

  private previousUrl: string;
  private client: UXStackInterface;
  private track: TrackingInterface;
  private isSupportListenerOptions?: boolean;
  private ignoreTags: { [key: string]: boolean } = {
    BODY: true,
    HTML: true,
  };

  private selectors: string[] = ['[role="link"]', '[role="button"]', '[onclick]', 'a', 'button', '[type="submit"]'];

  private listeners: { [key: string]: boolean } = {
    //change: this.onChange.bind(this),
    click: this.onClick.bind(this),
    //submit: this.onSubmit.bind(this),
  };

  constructor() {
    this.name = 'autocollect';
    this.previousUrl = document.location.href;
  }

  public load(client: UXStackInterface, options: UXStackOptions): void {
    Logger.info('load autocollect module');

    this.client = client;
    this.track = client.getModule('track') as TrackingInterface;

    this.isSupportListenerOptions = this.checkSupportListenerOptions();

    this.register();
  }

  private checkSupportListenerOptions(): boolean {
    let passiveSupported = false;

    const options = Object.defineProperty({}, 'passive', {
      get() {
        passiveSupported = true;
      },
    });

    try {
      window.addEventListener('test', null, options);
      window.removeEventListener('test', null, options);
    } catch (err) {
      Logger.debug('Listener options is not supported', err);
    }

    return passiveSupported;
  }

  private getListenerOptions(options: AddEventListenerOptions): AddEventListenerOptions | boolean {
    return this.isSupportListenerOptions ? options : options.capture || false;
  }

  private register(): void {
    this.client.ready(() => {
      this.track.page();
      this.track.performance();
    });

    /*
    let previousUrl = '';
const observer = new MutationObserver(function(mutations) {
  if (location.href !== previousUrl) {
      previousUrl = location.href;
      console.log(`URL changed to ${location.href}`);
    }
});
const config = {subtree: true, childList: true};
observer.observe(document, config);
    */

    // see: https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
    const observer = new MutationObserver(this.onMutation.bind(this));

    observer.observe(document, {
      attributes: false,
      childList: true,
      subtree: true,
    });

    this.applyListener();
    /*
        document.addEventListener('click', this.onClick.bind(this), this.getListenerOptions({
            capture: false,
            passive: true,
        }));
*/
  }

  private applyListener(): void {
    const selector = this.selectors.join(',');

    const elements = document.querySelectorAll(selector);

    for (const element of Array.prototype.slice.call(elements)) {
      if (element.nodeType !== Node.ELEMENT_NODE) {
        continue;
      }

      if (element._uxsseen && element._uxsseen === true) {
        Logger.debug('Element already processed', element);

        continue;
      }

      Object.keys(this.listeners).forEach((key) => {
        Logger.debug('Apply', key, 'on', element);

        element.addEventListener(
          key,
          this.listeners[key],
          this.getListenerOptions({
            capture: true,
            passive: true,
          }),
        );
      });

      element._uxsseen = true;
    }
  }

  private onMutation(mutations: MutationRecord[], observer: MutationObserver): void {
    Logger.debug('Mutations are observed', mutations, observer);

    if (location.href !== this.previousUrl) {
      this.previousUrl = location.href;

      Logger.debug(`URL changed to ${location.href}`);

      // generate a new correlation id for the new page
      this.track.pageChanged();

      this.track.page();
      // this.track.performance();
    }

    this.applyListener();
  }
  /*
    private getClickedElement(event: Event): Element {
        const clickedElement = (window.event) ? window.event.srcElement : event.target;

        const tags = document.getElementsByTagName((clickedElement as any).tagName);

        for (let i = 0; i < tags.length; ++i) {
            if (tags[i] === clickedElement) {
                return
                arrayWithElements.push({tag:clickedElement.tagName,index:i});
                //console.log(arrayWithElements);
            }
        }
    }
*/
  /*
    private getScrollCoordinate(): { x: number; y: number } {
        const supportPageOffset = window.pageXOffset !== undefined;
        const isCSS1Compat = (document.compatMode || '') === 'CSS1Compat';

        const x = supportPageOffset
            ? window.pageXOffset
            : isCSS1Compat
            ? document.documentElement.scrollLeft
            : document.body.scrollLeft;
        const y = supportPageOffset
            ? window.pageYOffset
            : isCSS1Compat
            ? document.documentElement.scrollTop
            : document.body.scrollTop;

        return {
            x,
            y,
        };
    }
*/
  private onClick(event: MouseEvent): void {
    //const target = (window.event) ? window.event.srcElement as Element : event.target as Element;
    /*
        if (this.ignoreTags.hasOwnProperty(target.tagName)) {
            Logger.debug('Ignore click on ', target);

            return;
        }
*/

    this.track.click(event);
    /*
        const selector = DOM.getSelector(event.currentTarget);

        Logger.debug('Intercept click on', event.currentTarget, ' (', selector, ')');

        const scroll = this.getScrollCoordinate();

        this.track.track('page', 'click', {
            coordinates: {
                client: {
                    x: event.clientX,
                    y: event.clientY,
                },
                offset: {
                    x: event.offsetX,
                    y: event.offsetY,
                },
                page: {
                    x: event.pageX,
                    y: event.pageY,
                },
                scroll: {
                    x: scroll.x,
                    y: scroll.y,
                },
            },
            selector,
            text: (event.currentTarget as HTMLElement).innerText,
        });
*/
    return;
  }
  /*
    private onChange(event: Event): void {
        Logger.debug('Intercept change on', event.currentTarget);
    }

    private onSubmit(event: Event): void {
        Logger.debug('Intercept submit on', event.currentTarget);
    }
*/
}
